import React, {Component} from 'react';
import styles from './ErrorPage.scss'

const labels = {
  '500': '500 Internal Server Error',
  'Oops': 'Oops, Something went wrong.',
  'Internal': 'The server encountered an internal error and was unable to complete your request.',
  'Home': "Nobody’s home...",
  'Address': 'Might be a wrong address. Make your way back to our homepage to start a fresh property search.',
  'Wrong': 'Something went wrong getting your property.',
  'Inactive': 'Sorry, the page you\'re looking for doesn\'t seem to exist.',
  'AlternativeAgent': ' Looking for a real estate agent? ',
  'AlternativeAgency': ' Looking for a real estate agency? '
};

class ErrorPage extends Component {
  render() {
    let errorType = this.props.type || 'notFound';
    return (
      <div>
        {errorType == 'serverError' ?
          <div className="container mt-5">
            <h2 className="display-4 text-danger">
              {labels['500']}
            </h2>
            <p className="text-black-50">
              {labels['Oops']}
            </p>
            <p className="text-black-50">
              {labels['Internal']}
            </p>
          </div>
        : errorType == 'notFound' ?
          <div className="container mt-5 text-center">
            <i className={`${styles.iconError} icon`}></i>
            <h2 className="display-4 text-danger">
              {labels['Home']}
            </h2>
            <p className="text-black-50">
              {labels['Address']}
            </p>
          </div>
        : errorType == 'propertyError' ?
          <div className="container mt-5 mb-5 text-center">
            <i className={`${styles.iconError} icon`}></i>
            <h2 className="text-danger mt-5">
              {labels['Wrong']}
            </h2>
            <p className="text-black-50">
              {labels['Address']}
            </p>
          </div>
        : errorType == 'inactiveAgent' ?
            <div className="container mt-5 mb-5 text-center">
              <i className={`${styles.iconError} icon`}></i>
              <h2 className="text-danger mt-5">
                {labels['Inactive']}
              </h2>
              <p className="text-black-50">
                {labels['AlternativeAgent']}<a href="/find-agent/">Search for agents now.</a>
              </p>
            </div>
        : errorType == 'inactiveAgency' ?
            <div className="container mt-5 mb-5 text-center">
              <i className={`${styles.iconError} icon`}></i>
              <h2 className="text-danger mt-5">
                {labels['Inactive']}
              </h2>
              <p className="text-black-50">
                {labels['AlternativeAgency']}<a href="/find-agent/">Search for agencies now.</a>
              </p>
            </div>
        : null}
      </div>
    );
  }
}

export default ErrorPage;
